import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root',
})
export class BienService {
  constructor(private http: HttpClient, private _cookieService:CookieService) {}

  requestRdvEstimation(data: any) {
    return this.http.post<any>(
      `${environment.apiUrl}/api/create/rdv/estimation`,
      data
    );
  }

  /**
   * getHeaders
   *
   * build our header for more security
   *
   * We send our token via this header
   *
   * @param isPostRequest {boolean}, type of the request
   */
  public getHeaders(isPostRequest: boolean): any {
    let userToken = this._cookieService.get('x-wsse');
    if (userToken === undefined) {
      let json = this._cookieService.get('user_token');
      if (json !== undefined) {
        userToken = JSON.parse(json).user_token;
      }
    }
    if (userToken !== undefined && userToken != "") {
      return new HttpHeaders({
        'x-wsse': userToken,
      });
    } else {
      return {};
    }
  }

  getBienById(bienId: any, includes?: string[]) {
    let optionalParams: any = {};
    optionalParams['headers'] = this.getHeaders(false);
    let url = `${environment.apiUrl}/api/biens/${bienId}/details/`;
    if (includes && includes.length > 0) {
      url += `?include=${includes.join(',')}`;
    }
    return this.http.get<any>(
      url, optionalParams
    );
  }
}
